
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/claims-processing",
      function () {
        return require("private-next-pages/ai/claims-processing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/claims-processing"])
      });
    }
  